document.addEventListener("DOMContentLoaded", function () {  
	/*====================================================
		Site language and country detection
	====================================================*/
	let isFrench = false;
	if (document.documentElement.lang === "fr") {
		isFrench = true;
	}
	

	/*====================================================
		VARIABLES
	====================================================*/
	// Use product data from the global variable
	const productData = window.productData;  
	const variantsData = {};

	// Elements for variants
	const variantStockElement = document.querySelector('.single-product .product-variant-stock');
	const variantStockLabel = document.querySelector('.product-variant-stock-label');
	const optionSelects = document.querySelectorAll('.single-product select');
	const stickyVariants = document.querySelector(".js__sticky-variants");

	// Elements for images carousel
	const thumbnails = document.querySelectorAll(".thumbnail");
	const lightboxModal = document.getElementById("lightbox-modal");
	const carouselImages = document.querySelectorAll(".carousel-image");
	const lightImgBtn = document.querySelector('.js__product-light-btn');
	const darkImgBtn = document.querySelector('.js__product-dark-btn');
	
	// Elements for price update
	const regularPriceElement = document.querySelector(".single-product .product-price-regular");
	const salePriceElement = document.querySelector(".single-product .product-price-sale");
	const currentPriceElement = document.querySelector(".single-product .product-price-current");
	const originalPriceElement = document.querySelector(".single-product .product-price-original");
	const stickyPrice = document.querySelectorAll(".js__sticky-price");
   
	// Elements for quantity update
	const quantityInput = document.getElementById("quantity-input");
	const quantityDecrease = document.getElementById("quantity-decrease");
	const quantityIncrease = document.getElementById("quantity-increase");

	// Elements for "add to cart" button
	const productForm = document.getElementById("product-form");
	const variantIdInput = document.getElementById("product-form-variant-id");
	const addToCartButton = document.getElementById("add-to-cart");
	const addToCartButtonMobile = document.getElementById("add-to-cart-mobile");
	const addToCartLoadingIcons = document.querySelectorAll(".mm-main-product-bottom-cta .cart-icon-loading");
	const cartCountElement = document.querySelectorAll(".js_cart-count");
	const stickyAddToCartBtn = document.querySelector(".js__sticky-cart-btn");
	const stickyCartIcon = document.querySelector(".js__sticky-cart-btn .cart-icon");
	const stickyCartIconLoading = document.querySelector(".js__sticky-cart-btn .cart-icon-loading");

	// Product properties elements
	const engravingInput = document.getElementById("engraving_text");
	const jobInput = document.getElementById("job_text");

	// Elements for sticky bar
	const stickyBar = document.querySelector(".product-sticky-bar");
	const priceContainer = document.querySelector(".js__product-price-container");

	/*====================================================
		VARIANTS
	====================================================*/
	// Input container frame border
	const variantContainer = document.querySelector(".js__variant-container");
	if (variantContainer) {
		const visibleVariants = variantContainer.querySelectorAll(".js__show-variant");
		const hiddenVariants = variantContainer.querySelectorAll(".js__hidden-variant");
		
		if (visibleVariants.length === 0 && hiddenVariants.length > 0) {
			variantContainer.classList.add("border-b-0");
			variantContainer.classList.remove("border-b");
		}
	}

	// Collect variant data from HTML
	document.querySelectorAll('[data-variant-id]').forEach((element) => {
		const variantId = element.getAttribute('data-variant-id');
		const variantQuantity = parseInt(element.getAttribute('data-variant-quantity'), 10);
		variantsData[variantId] = variantQuantity;
	});

    /**
     * Function to update stock and price based on selected options
     */
	function updateVariantInfo() {
		const selectedOptions = Array.from(optionSelects).map(select => select.value);
		const selectedVariantId = getVariantIdFromOptions(selectedOptions);

		if (selectedVariantId && variantsData[selectedVariantId] !== undefined) {
			const stockQuantity = variantsData[selectedVariantId];

			if(stockQuantity > 0) {
				if (variantStockLabel) variantStockLabel.textContent = isFrench ? 'En stock' : 'In stock';
				if (variantStockElement) variantStockElement.textContent = '';
				addToCartButton.disabled = false;
				addToCartButton.classList.remove("disabled");
				if (addToCartButtonMobile) { addToCartButtonMobile.disabled = false; addToCartButtonMobile.classList.remove("disabled"); }
				stickyAddToCartBtn.disabled = false;
				stickyAddToCartBtn.classList.remove("disabled");
			} else {
				if (variantStockElement) variantStockElement.textContent = stockQuantity < 0 ? '0' : stockQuantity;
				addToCartButton.disabled = true;
				addToCartButton.classList.add("disabled");
				if (addToCartButtonMobile) { addToCartButtonMobile.disabled = true; addToCartButtonMobile.classList.add("disabled"); }
				stickyAddToCartBtn.disabled = true;
				stickyAddToCartBtn.classList.add("disabled");
			}
			if(stockQuantity < 11 && stockQuantity > 0) {
				if (variantStockLabel) variantStockLabel.textContent = 'stock';
				if (variantStockElement) variantStockElement.textContent = stockQuantity;
			}

			// Update the price based on selected variant
			const selectedVariant = productData.variants.find(variant => variant.id == selectedVariantId);
			if (selectedVariant) {
				updatePrice(selectedVariant);  // Call the updated price function
			}
			// Update hidden variant ID input in the form
			if (variantIdInput) variantIdInput.value = selectedVariantId;

			// Update sticky variants
			const filteredOptions = selectedOptions.filter(value => value !== "Default Title");
			stickyVariants.textContent = filteredOptions.join(" - ");
		}
	}

	/**
	 * Function to get variant ID from selected options
	 */
	function getVariantIdFromOptions(selectedOptions) {
		return productData.variants.find(variant =>
			variant.options.every((option, index) => option === selectedOptions[index])
		)?.id; // Return variant id if found
	}

	/**
	 * Function to find the matching variant based on selected options
	 */
	function findMatchingVariant() {
		const selectedOptions = Array.from(document.querySelectorAll('.single-product select')).map(select => select.value);
		return productData.variants.find(variant =>
			variant.options.every((option, index) => option === selectedOptions[index])
		);
	}

	/**
	 * Function to update the price
	 */
	function updatePrice(selectedVariant) {
		const price = parseFloat(selectedVariant.price);
		const compareAtPrice = parseFloat(selectedVariant.compare_at_price);
		
		// Convert cents to euros
		const formattedPrice = (price / 100).toFixed(2) + ' €';
		const formattedCompareAtPrice = compareAtPrice ? (compareAtPrice / 100).toFixed(2) + ' €' : '';
		
		if (compareAtPrice && price < compareAtPrice) {
			// Show sale price
			salePriceElement.style.display = 'flex';
			regularPriceElement.style.display = 'none';
			currentPriceElement.textContent = formattedPrice;
			originalPriceElement.textContent = formattedCompareAtPrice;
			stickyPrice.forEach(el => {
				el.textContent = formattedPrice;
			});
		} else {
			// Show regular price
			salePriceElement.style.display = 'none';
			regularPriceElement.style.display = 'inline';
			regularPriceElement.textContent = formattedPrice;
			stickyPrice.forEach(el => {
				el.textContent = formattedPrice;
			});
		}
		

	}

	// Add event listeners to option selects
	optionSelects.forEach(select => {
		select.addEventListener('change', () => {
			updateVariantInfo();
			slideToMacthingVariantImage();
		});
	});

	// Initialize with the first variant
	updateVariantInfo();

	/*====================================================
		IMAGES CAROUSEL
	====================================================*/
	/**
	 * Init Swiper slider for main carousel
	 */
	const mainProductSlider = new Swiper(".js__slider-product-main", {
		slidesPerView: 1.2,
		loop: false,
		breakpoints: {
			768: {
				slidesPerView: 1,
			},
		},
		on: {
			slideChange: function () {
				const activeSlide = mainProductSlider.slides[mainProductSlider.activeIndex];
				const activeImageId = activeSlide?.dataset?.imageId;
				if (activeImageId) {
					updateActiveThumbnail(activeImageId);
				}
			},
		},
	});

	/**
	 * Change slide position based on the image index
	 */
	function slideToImage(imageId) {
		const slideIndex = [...mainProductSlider.slides].findIndex(
			(slide) => slide.getAttribute("data-image-id") === imageId
		);
	
		if (slideIndex !== -1) {
			mainProductSlider.slideTo(slideIndex);
		}
	}

	/**
	 * Slide to the matching variant image
	 */
	function slideToMacthingVariantImage() {
		const matchingVariant = findMatchingVariant();
		if (matchingVariant?.featured_image?.id) {
			const imageId = String(matchingVariant.featured_image.id);
			const slideIndex = [...mainProductSlider.slides].findIndex(
				(slide) => slide.getAttribute("data-image-id") === imageId
			);
			if (slideIndex !== -1) {
				mainProductSlider.slideTo(slideIndex);
			}
		}
	}

	/**
	 * Highlights thumbnail that matches the active main slide.
	 */
	function updateActiveThumbnail(imageId) {
		thumbnails.forEach((thumb) => {
			const isActive = thumb.getAttribute("data-image-id") === imageId;
			thumb.classList.toggle("active", isActive);
			if (isActive) {
				thumb.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "start" });
			}
		});
	}

	// Add click listeners to thumbnails that slide the main Swiper to the matching image
	thumbnails.forEach((thumb) => {
		thumb.addEventListener("click", () => {
			const imageId = thumb.getAttribute("data-image-id");
			const slideIndex = [...mainProductSlider.slides].findIndex(
				(slide) => slide.getAttribute("data-image-id") === imageId
			);
			if (slideIndex !== -1) {
				mainProductSlider.slideTo(slideIndex);
			}
		});
	});

	// Open lightbox on main carousel image click
	let lightboxSwiper;
	carouselImages.forEach((image, index) => {
		image.addEventListener("click", function () {
			lightboxModal.classList.remove("hidden");
			// Initialize Swiper only once
			if (!lightboxSwiper) {
				lightboxSwiper = new Swiper(".js__lightbox-swiper", {
					loop: false,
					zoom: true,
					navigation: {
						nextEl: ".lightbox-nav-next",
						prevEl: ".lightbox-nav-prev",
					},
				});
			}
			// Jump to correct slide
			lightboxSwiper.slideTo(index, 0);
		});
	});

	// Close lightbox
	document.querySelector(".lightbox-close").addEventListener("click", () => {
		lightboxModal.classList.add("hidden");
	});

	// Close lightbox when clicking outside the slider
	lightboxModal.addEventListener("click", (e) => {
		if (e.target === lightboxModal) {
			lightboxModal.classList.add("hidden");
		}
	});

	// Slide to dark / light carousel image
	if( lightImgBtn ) {
		lightImgBtn.addEventListener("click", function() {
			slideToImage('img-light-mode');
		});
	}
	if( darkImgBtn ) {
		darkImgBtn.addEventListener("click", function() {
			slideToImage('img-dark-mode');
		});
	}

	/*====================================================
		QUANTITY INPUT
	====================================================*/
	// Event listeners for quantity buttons
	quantityDecrease?.addEventListener("click", function () {
		let currentQuantity = parseInt(quantityInput.value, 10);
		// Decrease the quantity by 1, ensuring it doesn't go below 1
		if (currentQuantity > 1) {
			quantityInput.value = currentQuantity - 1;
		}
		checkStockAvailability();
	});
	quantityIncrease?.addEventListener("click", function () {
		let currentQuantity = parseInt(quantityInput.value, 10);

		getCartItems().then(cartItems => {
			const selectedVariant = findMatchingVariant();
			if (!selectedVariant) {
				let alertMessage = isFrench ? 'Merci de sélectionner des options valides.' : 'Please select correct options.';
				alert(alertMessage);
				return;
			}
	
			const variantId = selectedVariant.id;
			const maxStock = variantsData[variantId] || 0;
			const quantityInCart = cartItems[variantId] || 0;
			let toastMessage = isFrench ? 'Vous avez atteint la quantité maximale disponible pour ce produit.' : 'You have reached the maximum quantity available for this product.';
			
			// Check if there is enough stock to increase the quantity
			if (currentQuantity + 1 <= maxStock - quantityInCart) {
				quantityInput.value = currentQuantity + 1;
			} else {
				showToast(6000, 'error', toastMessage);
			}
			checkStockAvailability();
		});
	});

    /*====================================================
		ADD TO CART
	====================================================*/
    /**
	 * Function to toggle cart icon visibility
	 */
	function toggleCartIcons(isLoading) {
		addToCartLoadingIcons.forEach(icon => {
			icon.classList.toggle('hidden', !isLoading);
		});
		if (stickyCartIcon) stickyCartIcon.style.display = isLoading ? 'none' : 'block';
		if (stickyCartIconLoading) stickyCartIconLoading.style.display = isLoading ? 'block' : 'none';
	}
	// Initially hide the loading icon
	toggleCartIcons(false);

	/**
	 * Function to get the quantity of the product in the cart
	 * @returns 
	 */
	function getCartItems() {
        return fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                return cart.items.reduce((acc, item) => {
                    acc[item.id] = item.quantity;
                    return acc;
                }, {});
            });
    }

	/**
	 * Function to check stock availability
	 */
	function checkStockAvailability() {
        getCartItems().then(cartItems => {
            const selectedVariant = findMatchingVariant();
            if (!selectedVariant) return;
            
            const variantId = selectedVariant.id;
            const maxStock = variantsData[variantId] || 0;
            const quantityInCart = cartItems[variantId] || 0;
            const requestedQuantity = parseInt(quantityInput.value, 10);

            if (quantityInCart + requestedQuantity > maxStock) {
                addToCartButton.disabled = true;
                addToCartButton.classList.add("disabled");
                if (addToCartButtonMobile) { addToCartButtonMobile.disabled = true; addToCartButtonMobile.classList.add("disabled"); }
                stickyAddToCartBtn.disabled = true;
                stickyAddToCartBtn.classList.add("disabled");
            } else {
                addToCartButton.disabled = false;
                addToCartButton.classList.remove("disabled");
                if (addToCartButtonMobile) { addToCartButtonMobile.disabled = false; addToCartButtonMobile.classList.remove("disabled"); }
                stickyAddToCartBtn.disabled = false;
                stickyAddToCartBtn.classList.remove("disabled");
            }
        });
    }

	/**
	 * Function to update the cart count in the bubble
	 */
	function updateCartCount() {
		fetch('/cart.js')
			.then(response => response.json())
			.then(cart => {
				const totalItems = cart.items.reduce((acc, item) => acc + item.quantity, 0);

				cartCountElement.forEach((count) => {
					count.textContent = totalItems;
					let cartBubble = count.closest('.cart-count-bubble');
					if (cartBubble.classList.contains('hidden')) {
						cartBubble.classList.add('flex');
						cartBubble.classList.remove('hidden');
					}
				});
			});
	}
  
	/**
	 * Function to add a product to the cart
	 */
	function addToCart(variantId, quantity) {
		let toastDuration = 6000;
		let toastMessage = isFrench ? 'Produit ajouté au panier !' : 'Product added to cart!';
		let toastBtnLabel = isFrench ? 'Voir le panier' : 'Go to cart';
		let toastMessageError = isFrench ? 'Erreur, le produit n\'a pas pu être ajouté au panier.' : 'Error: Product could not be added to cart.';

		toggleCartIcons(true);

		// Capture the engraving text
		const engravingText = engravingInput ? engravingInput.value : '';
		const jobText = jobInput ? jobInput.value : '';

		// Add properties if they exist and are not empty
		const properties = {};
		if (engravingInput && engravingText.trim() !== '') {
			let engravingPropertyName = isFrench ? 'Gravure' : 'Engraving';
			properties[engravingPropertyName] = engravingText;  
		}
		if (jobInput && jobText.trim() !== '') {
			properties[jobInput.getAttribute("data-field-name")] = jobText;  
		}

		fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
            body: JSON.stringify({
                id: variantId, 
                quantity: quantity, 
                properties: properties
            })
        })
        .then(response => response.json())
        .then(() => {
			updateCartCount();
			toggleCartIcons(false);
            checkStockAvailability();
			document.dispatchEvent(new CustomEvent('cart:item-added'));
        })
        .catch(error => {
            showToast(toastDuration, 'error', toastMessageError);
            console.error('Error:', error);
			toggleCartIcons(false);
        });
	}
	checkStockAvailability();

	if (quantityInput) quantityInput.addEventListener("input", checkStockAvailability);
	// Handle product form submission (add to cart)
	productForm.addEventListener('submit', function (event) {
		event.preventDefault();
		getCartItems().then(cartItems => {
			const selectedVariant = findMatchingVariant();
			if (!selectedVariant) {
				let alertMessage = isFrench ? 'Merci de sélectionner des options valides.' : 'Please select correct options.';
				alert(alertMessage);
				return;
			}

			const variantId = selectedVariant.id;
			const maxStock = variantsData[variantId] || 0;
			const quantityInCart = cartItems[variantId] || 0;
			const requestedQuantity = parseInt(quantityInput ? quantityInput.value : '1', 10);
			let toastMessage = isFrench ? 'Vous avez atteint la quantité maximale disponible pour ce produit.' : 'You have reached the maximum quantity available for this product.';

			if (quantityInCart + requestedQuantity > maxStock) {
				showToast(6000, 'error', toastMessage);
				return;
			}

			addToCart(selectedVariant.id, requestedQuantity);
		});
	});

	/*====================================================
		CUSTOM FIELDS
	====================================================*/
	// Engraving field
	if (engravingInput) {
		engravingInput.addEventListener("input", function () {
			// Replace any non-alphanumeric characters (including accents) with an empty string (allow spaces and dashes)
			this.value = this.value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-zA-Z0-9 .-]/g, "");
		});
	}

	/*====================================================
		STICKY BAR
	====================================================*/
	// Add to cart button
	stickyAddToCartBtn.addEventListener("click", function() {
		productForm.requestSubmit();
	});

	// Display sticky bar after scrolling past the product price
	if (priceContainer && stickyBar) {
        let hasScrolledPast = false;

        new IntersectionObserver(entries => {
            if (!entries[0].isIntersecting) hasScrolledPast = true;
        }, { threshold: 0 }).observe(priceContainer);

        window.addEventListener("scroll", () => {
            if (hasScrolledPast && priceContainer.getBoundingClientRect().bottom <= 0) {
                stickyBar.querySelector(".sticky-bar-container").classList.remove("opacity-0", "pointer-events-none");
                stickyBar.querySelector(".sticky-bar-container").classList.add("pointer-events-all");
            } else {
                stickyBar.querySelector(".sticky-bar-container").classList.add("opacity-0", "pointer-events-none");
				stickyBar.querySelector(".sticky-bar-container").classList.remove("pointer-events-all");
            }
        });
    }

    /*====================================================
		TOAST
	====================================================*/
    /**
	 * Function to show toast message
	 * @param {int} duration Toast display time.
	 * @param {string} type 'success' or 'error.
	 * @param {string} message The message to display in the toast.
	 * @param {object} link 'url' and 'label' to display a link button.
	 */
	function showToast(duration, type, message, link = null) {
		const toastContainer = document.createElement('div');
		toastContainer.className = 'toast-container';
		document.body.appendChild(toastContainer);

		const toast = document.createElement('div');
		toast.className = 'toast';

		// Add class based on the toast type (success or error)
		if (type === 'success') {
			toast.classList.add('success');
		} else if (type === 'error') {
			toast.classList.add('error');
		}

		// Add the message text
		const messageElement = document.createElement('span');
		messageElement.textContent = message;
		toast.appendChild(messageElement);

		// Add the link button if the link parameter is provided
		if (link && link.url && link.label) {
			const linkButton = document.createElement('a');
			linkButton.href = link.url;
			linkButton.textContent = link.label;
			linkButton.className = 'toast-link';
			toast.appendChild(linkButton);
		}

		toastContainer.appendChild(toast);

		// Automatically remove the toast after a duration
		setTimeout(() => {
			toastContainer.classList.add('opacity-0');
			setTimeout(() => {
				toastContainer.remove();
				toast.remove();
			}, 300); // Matches the fade-out transition duration
		}, duration);
	}
});
